import React, { useContext, useState } from "react"
import { Link } from "gatsby"
import { LanguageContext } from "../context"
//import { homePagePaths, translate } from '../translate'
import burgerImage from "../assets/images/icons-32-x-32-generic-menu-burger/icons-32-x-32-generic-menu-burger@3x.png"
import crossImage from "../assets/images/icons-32-x-32-generic-cross/icons-32-x-32-generic-cross@3x.png"
import logo from "../assets/images/logo-goel.png"
//import Icon from "./icon"
import NavigationMenu from "./menu"
import { slide as Menu } from "react-burger-menu"
import { useBreakpoint } from "gatsby-plugin-breakpoints"
import socialList from "./social-media/social-media-list"
import SocialMediaList from "./social-media"


const BurgerMenu = (props) => {
  const { lang } = props

  const [menuOpen, setMenuOpen] = useState(false)

  //const handleStateChange = ({isOpen}) => {
  //  setMenuOpen({ menuOpen: isOpen });
  //}

  const closeMenu = () => {
    setMenuOpen({ menuOpen: false });
  }

  //const navigateLanguage  = (value) => {
  //  closeMenu()
  //  const toLanguage = value
  //  navigate(translationPaths[toLanguage])
  //}

  //const url = location.href ? location.href : '';

  const toggleMenu = ({ isOpen }) => {
  const menuWrap = document.querySelector(".bm-menu-wrap");
  isOpen
    ? menuWrap.setAttribute("aria-hidden", false)
    : menuWrap.setAttribute("aria-hidden", true);
  };
  const { translationPaths, langcode } = useContext(LanguageContext)
  const breakpoints = useBreakpoint()

  return (

        <Menu
          onStateChange={toggleMenu}
          right
          customBurgerIcon={ <img src={burgerImage}/> }
          customCrossIcon={ <img src={crossImage}/> }
          width={ '370px' }
          noOverlay
        >
        <div className="global-language-menu">

          <Link onClick={() => closeMenu()} className={`menu-item ${lang === 'ca' ? 'active' : ''}`} to={translationPaths['ca'] || '/'}>
            CAT
          </Link>
          <Link
            onClick={() => closeMenu()}
            className={`menu-item ${lang === 'es' ? 'active' : ''}`}
            to={translationPaths['es'] || '/es'}
          >
            ESP
          </Link>
          <Link
            onClick={() => closeMenu()}
            className={`menu-item ${lang === 'en' ? 'active' : ''}`}
            to={translationPaths['en'] || '/en'}
          >
            ENG
          </Link>
         </div>
         <div className="sidebar-menu-wrapper">
           {breakpoints.md &&
             <>
             <div className="global-sidebar-primary-menu">
               <NavigationMenu
                  menuName="goel-navegacio-principal"
                  itemClasse="H4-Light-L---black"
                />
             </div>
             <div className="line-color"></div>
             </>
           }

           <div className="global-secondary-menu">
             <NavigationMenu
                menuName="goel-navegacion-secundaria"
                itemClasse="H4-Light-L---black"
              />
           </div>
         </div>

         <div className="sidebar-menu-footer">
          <img src={logo} alt="Fundació Privada Goel" className="sidebar-logo" />
          <div className="unida-address">
            <div className="address mb-17">
            Avinguda Béjar, 299,
            08226 Terrassa
            </div>
            <div className="phone mb-17">Telf. (+34) 937 807 614{`\n`}</div>
            <div className="schedule mb-58">
            Dll-Div: 9:00 - 15:00 <br />
            </div>
          </div>
          <SocialMediaList
            socialList={socialList}
          />
         </div>
        </Menu>

  )
}

export default BurgerMenu
